import * as React from "react";
const SvgFiRrPhonePause = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-phone-pause_svg__a)">
      <path
        fill="#062147"
        d="M19.981 7.023v-6a1 1 0 0 1 2 0v6a1 1 0 1 1-2 0m-3 1a1 1 0 0 0 1-1v-6a1 1 0 1 0-2 0v6a1 1 0 0 0 1 1m6.095 13.116-.912 1.05c-8.19 7.84-28.12-12.084-20.4-20.3l1.15-1a3.08 3.08 0 0 1 4.328.04c.031.03 1.882 2.438 1.882 2.438a3.1 3.1 0 0 1-.005 4.28L7.96 9.1a12.78 12.78 0 0 0 6.932 6.947l1.464-1.165a3.1 3.1 0 0 1 4.282-.008s2.407 1.853 2.438 1.885a3.1 3.1 0 0 1 .001 4.38M21.7 18.215s-2.4-1.841-2.425-1.872a1.12 1.12 0 0 0-1.549 0 471 471 0 0 1-2.044 1.636 1 1 0 0 1-.979.15A15 15 0 0 1 5.88 9.319a1 1 0 0 1 .146-.995s1.607-2.017 1.635-2.044a1.1 1.1 0 0 0 0-1.55c-.032-.03-1.873-2.423-1.873-2.423a1.1 1.1 0 0 0-1.51.038l-1.15 1.005c-5.64 6.778 11.63 23.093 17.572 17.477l.912-1.05a1.12 1.12 0 0 0 .088-1.56"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-phone-pause_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPhonePause;
